interface Action {
    payload: any,
    type: string
}

const CaseTypesReducer = (state = [], action: Action) => {
    switch (action.type) {
        case 'GET_CASE_TYPES':
            return action.payload;
        default:
            return state;
    }
};

export default CaseTypesReducer;
